import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolTwoToneSvg from "@ant-design/icons-svg/es/asn/ToolTwoTone";
import AntdIcon from '../components/AntdIcon';
var ToolTwoTone = function ToolTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ToolTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ToolTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ToolTwoTone';
}
export default RefIcon;